
import EtsyIntegrationCard from "@/components/EtsyIntegrationCard";
import SubscriptionGuard from "@/components/SubscriptionGuard";

interface SharedPageHeaderProps {
  title: string;
  description: string;
  feature: string;
  isConnected: boolean;
  onConnectionChange: (connected: boolean) => void;
  children?: React.ReactNode;
}

const SharedPageHeader = ({ 
  title, 
  description, 
  feature, 
  isConnected, 
  onConnectionChange, 
  children 
}: SharedPageHeaderProps) => {
  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">{title}</h1>
          <p className="text-gray-600 mt-2">{description}</p>
        </div>
      </div>

      <SubscriptionGuard feature={feature}>
        <EtsyIntegrationCard 
          isConnected={isConnected} 
          onConnectionChange={onConnectionChange} 
        />
        {children}
      </SubscriptionGuard>
    </div>
  );
};

export default SharedPageHeader;
